import React, { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom";
import { Container, Row, Col, NavDropdown, Navbar, Nav, Breadcrumb, Table, Tabs, Tab } from 'react-bootstrap';
import { Initial } from 'react-initial'
import ReactPaginate from 'react-paginate';
import img2 from "../../Login/img/logo.png"
import Sidebar from "../Sidebar/Sidebar";
import Topbar from "../Topbar/Topbar";
import { ToastContainer, toast } from 'react-toastify';
import config from "../../config/config";
import axios from "axios";
import LoadingSpinner from "../LoadingSpinner";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import moment from "moment/moment";
import { formatTime, getArchivedData, getLanguage, statusText } from '../../Utils/utils';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@mui/material/LinearProgress';
import ConfirmationModal from "../Modals/ConfirmationModal";
import DataModal from "../Modals/DataModal";
import { connect } from "react-redux";
import CustomSearch from "../CustomSearch";
import { TimetoConvert } from "../../Utils/TimeUtils";
import SuccessModal from "../Modals/SuccessModal";

const Archived = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([])
  const [maxPageLimit, setMaxPageLimit] = useState(5)
  const [pageCount, setPageCount] = useState(2);
  const [selectRowsArr, setSelectRowsArr] = useState([]);
  const [archivedArray, setArchivedArray] = useState([]);
  const [archivedData, setArchivedData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [confirmShow, setConfirmShow] = useState(false);
  const [noteuserId, setNoteUserId] = useState('');
  const [homeEmail, setHomeEmail] = useState('');
  const [routeName, setRouteName] = useState('');
  const [reloadData, setReloadData] = useState(false);
  const [archiveReason, setArchiveReason] = useState('');
  const [reasonShow, setReasonShow] = useState(false);
  const [filterText, setFilterText] = useState('');
  const handleFilterChange = (e) => { setFilterText(e.target.value); };
  const [show, setShow] = useState(false);
  const selectedStuIds = selectRowsArr?.map((data) => data?.id)


  const getAllArchivedData = async () => {
    setIsLoading(true)
    var res = await getArchivedData()
    if (res.status == 200) {
      setArchivedData(res.data)
      setArchivedArray(res.data)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getAllArchivedData()
    setPageCount(data.length / maxPageLimit)
  }, [])

  useEffect(() => {
    getAllArchivedData()
  }, [reloadData])

  const archiveColumns = [
    {
      id: 1,
      name: "Student Id",
      width: '110px',
      selector: (row) =>
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.LD_SID}
        </div>
    },
    {
      id: 2,
      name: "Rank",
      cell: (row) =>
        <>
          <div className="row">
            <div className='cell-upper' style={{ fontSize: '12px' }}>{row.RANK}</div>
          </div>
        </>,
      width: "80px",
      sortable: true,
    },
    {
      id: 3,
      name: "First Name",
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.FIRSTNAME}
        </div>
      ),
      sortable: true,
      width: "110px",
    },
    {
      id: 4,
      name: "Last Name",
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.LASTNAME}
        </div>
      ),
      sortable: true,
      width: "110px",
    },
    {
      id: 5,
      name: "Home Email",
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.HOME_EMAIL}
        </div>
      ),
      width: "250px"
    },
    {
      id: 8,
      name: "Availability",
      cell: (row) =>
        <>
          <div className="row py-2">
            {row?.MON_FROM &&
              <div className='cell-up' style={{ fontSize: '12px' }}>MON - {formatTime(row?.MON_FROM, row?.MON_TO)}</div>}
            {row?.TUE_FROM &&
              <div className='cell-up' style={{ fontSize: '12px' }}>TUE - {formatTime(row.TUE_FROM, row.TUE_TO)} </div>}
            {row?.WED_FROM &&
              <div className='cell-up' style={{ fontSize: '12px' }}>WED - {formatTime(row.WED_FROM, row.WED_TO)} </div>}
            {row?.THUR_FROM &&
              <div className='cell-up' style={{ fontSize: '12px' }}>THUR - {formatTime(row.THUR_FROM, row.THUR_TO)} </div>}
            {row?.FRI_FROM &&
              <div className='cell-up' style={{ fontSize: '12px' }}>FRI - {formatTime(row.FRI_FROM, row.FRI_TO)} </div>}
            {row?.SAT_FROM &&
              <div className='cell-up' style={{ fontSize: '12px' }}>SAT - {formatTime(row.SAT_FROM, row.SAT_TO)} </div>}
            {row?.SUN_FROM &&
              <div className='cell-up' style={{ fontSize: '12px' }}>SUN - {formatTime(row.SUN_FROM, row.SUN_TO)} </div>}
          </div>
        </>,
      width: "160px"
    },
    {
      id: 8,
      name: "Availability in EST",
      cell: (row) =>
        <>
          <div className="row py-2">
            {row?.MON_FROM &&
              <div className='cell-up' style={{ fontSize: '12px' }}>MON - {TimetoConvert(row?.MON_FROM, row?.MON_TO, row?.TIMEZONE)}</div>}
            {row?.TUE_FROM &&
              <div className='cell-up' style={{ fontSize: '12px' }}>TUE - {TimetoConvert(row.TUE_FROM, row.TUE_TO, row.TIMEZONE)} </div>}
            {row?.WED_FROM &&
              <div className='cell-up' style={{ fontSize: '12px' }}>WED - {TimetoConvert(row.WED_FROM, row.WED_TO, row.TIMEZONE)} </div>}
            {row?.THUR_FROM &&
              <div className='cell-up' style={{ fontSize: '12px' }}>THUR - {TimetoConvert(row.THUR_FROM, row.THUR_TO, row.TIMEZONE)} </div>}
            {row?.FRI_FROM &&
              <div className='cell-up' style={{ fontSize: '12px' }}>FRI - {TimetoConvert(row.FRI_FROM, row.FRI_TO, row.TIMEZONE)} </div>}
            {row?.SAT_FROM &&
              <div className='cell-up' style={{ fontSize: '12px' }}>SAT - {TimetoConvert(row.SAT_FROM, row.SAT_TO, row.TIMEZONE)} </div>}
            {row?.SUN_FROM &&
              <div className='cell-up' style={{ fontSize: '12px' }}>SUN - {TimetoConvert(row.SUN_FROM, row.SUN_TO, row.TIMEZONE)} </div>}
          </div>
        </>,
      width: "160px"
    },
    {
      id: 6,
      name: "Timezone",
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.TIMEZONE.includes('-') ? row.TIMEZONE.split('/')[0].trim() : row.TIMEZONE}
        </div>
      ),
      width: "100px"
    },
    {
      id: 7,
      name: "Start Date",
      sortable: true,
      cell: (row) => <div style={{ fontSize: '12px' }}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>{moment(row.AVAILABLE_START_DATE).format('MM/DD/YYYY')}</div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "100px"
    },
    {
      id: 8,
      name: "End Date",
      sortable: true,
      cell: (row) => <div style={{ fontSize: '12px' }}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>{moment(row.AVAILABLE_END_DATE).format('MM/DD/YYYY')}</div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "100px"
    },
    {
      id: 9,
      name: " Old Course No.",
      sortable: true,
      width: "130px",
      cell: (row) => <div style={{ fontSize: '12px' }}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>{row.COURSE_NUMBER}</div>,
      ignoreRowClick: true,
      allowOverflow: true,
    },
    {
      id: 9,
      name: "New Course No.",
      sortable: true,
      width: "140px",
      cell: (row) => <div style={{ fontSize: '12px' }}
        onClick={() => {
          setShowModal(true)
          setSelectedRow(row)
        }}>{row.COURSE_NUMBER}</div>,
      ignoreRowClick: true,
      allowOverflow: true,
    },
    {
      id: 11,
      name: "Course Type",
      selector: (row) =>
        <div style={{ fontSize: '12px' }}>
          {row.COURSETYPE}
        </div>,
      sortable: true,
      width: "120px"
    },
    {
      id: 12,
      name: "SOU Sent On",
      cell: (row) => <div style={{ fontSize: '12px' }}>{row.sou_sent_on == null ? '' : moment(row.sou_sent_on).format('MM/DD/YYYY')}</div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "100px"
    },
    {
      id: 13,
      name: "SOU Status",
      cell: (row) => <div style={{ fontSize: '12px' }}
      >{statusText(row.status_id)}</div>,
      ignoreRowClick: true,
      allowOverflow: true,
      width: "100px"
    },
    {
      id: 14,
      name: "Archived Date",
      selector: (row) =>
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: '12px'
          }}>
          {moment(row.archived_date).format('MM/DD/YYYY h:mm a')}
        </div>,
      sortable: true,
      width: "110px"
    },
    {
      id: 15,
      name: "Archived Reason",
      selector: (row) => <div style={{ cursor: 'pointer', color: '#00008b', fontSize: '12px' }}
        onClick={() => {
          setReasonShow(true)
          setArchiveReason(row.reason)
        }} >{row.reason}</div>,
      sortable: true,
      width: "140px"
    },
    {
      id: 16,
      name: "Action",
      cell: (row) => <div className='cell-link'
      ><><i className="text-success fas fa-window-restore mr-2" title="Restore"
        onClick={() => {
          setConfirmShow(true)
          setNoteUserId(row?.LD_SID)
          setHomeEmail(row?.HOME_EMAIL)
          setRouteName('restore-archive-data')
        }}></i>
          <i className="text-danger fas fa-trash ml-3" title="Delete"
            onClick={() => {
              setConfirmShow(true)
              setNoteUserId(row?.LD_SID)
              setHomeEmail(row?.HOME_EMAIL)
              setRouteName('delete-archive-data')
            }}></i></></div>,
    },
  ];

  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "ALL"
  };
  const conditionalRowStyles = [
    {
      when: row => row.space_a_ind === 'T',
      style: {
        backgroundColor: '#fb6f46',
        color: 'black',
        '&:hover': {
          backgroundColor: '#FDB7A2 !important',
          cursor: 'pointer',
        },
      },
    },
  ];

  const useStyles = makeStyles(theme => ({
    root: {
      width: '50%',
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
    },
  }));

  // The Material UI way...
  const LinearIndeterminate = () => {
    const classes = useStyles();

    return (
      <div className={classes.root}>
        <LinearProgress />
      </div>
    );
  };


  const onSubmit = async () => {
    setIsLoading(true)
    let path = config.siteUrl;
    var token = localStorage.getItem('access_token');

    const requestData = {
      student_ids: selectedStuIds,
    };

    try {
      const res = await axios.post(path + '/classes/multiple-restore-archive-data', requestData, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (res.data.status === 200) {
        setIsLoading(false);
        getAllArchivedData();
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  }

  const onCloseRoll = () => {
    setShow(false);
    onSubmit();
  }


  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <div className="main-div">
        <div className="blue-back"></div>
        <Row className="w-100 m-auto">
          {/* <Col md={2}>
            <Sidebar />
          </Col> */}
          <Col md={12} className="right-pad">
            <div className="main-text">
              <Topbar />
              <div>
                <div className={'new-card'} style={{ padding: "20px 15px 30px 15px" }}>
                  <div className='top-row'>
                    <div className="row">
                      <div className="col-lg-9">
                        <div className='heading-text'>
                          Archived Data
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <CustomSearch filterText={filterText} onFilter={handleFilterChange} />
                      </div>
                    </div>
                  </div>
                  <div className="row mb-4">
                    <div className="col-md-12">
                      {archivedArray.length > 0 ?
                        <div className="card m-overflow-h todo-card-list" style={{ border: 'none' }}>
                          <div className="card-body m-p-0 data-tab p-0">
                            <DataTableExtensions
                              columns={archiveColumns}
                              data={archivedArray.filter((item) => Object.values(item).some((value) => String(value).toLowerCase().includes(filterText.toLowerCase().trim())))}
                              print={false}
                              export={false}
                              filter={false}
                            >
                              <DataTable
                                pagination
                                paginationComponentOptions={paginationComponentOptions}
                                selectableRows
                                conditionalRowStyles={conditionalRowStyles}
                                // selectableRowsNoSelectAll={true}
                                onSelectedRowsChange={({ selectedRows }) => setSelectRowsArr(selectedRows)}
                                persistTableHead
                                progressPending={isLoading}
                                progressComponent={<LinearIndeterminate />}
                                paginationPerPage={10}
                                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                highlightOnHover
                                className="custom-table-border"
                                customStyles={{
                                  headCells: {
                                    style: {
                                      backgroundColor: '#8A8A8A',
                                      color: '#ffffff',
                                    },
                                  },
                                }}
                              />
                            </DataTableExtensions>

                            <Row className="w-100 display-center mt-5">
                              <div className="btn-box">
                                <div className="main-btn"
                                  onClick={() => {
                                    if (selectRowsArr.length > 0) {
                                      setShow(true);
                                    } else {
                                      toast.error('Please select data')
                                    }
                                  }}>
                                  Archive Restore
                                </div>
                              </div>
                            </Row>
                          </div>
                        </div>
                        :
                        <div className="no-record">
                          There are no records to display.
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        {confirmShow == true ?
          <ConfirmationModal
            confirmShow={confirmShow}
            setConfirmShow={setConfirmShow}
            noteUserId={noteuserId}
            homeEmail={homeEmail}
            setReloadData={setReloadData}
            routeName={routeName}
          />
          : null}
        {reasonShow == true ?
          <DataModal
            reasonShow={reasonShow}
            setReasonShow={setReasonShow}
            data={archiveReason}
            title='Archive Reason'
          />
          : null}
        {show == true ?
          <SuccessModal
            isSuccessShow={show}
            setIsSuccessShow={setShow}
            onClose={onCloseRoll}
          />
          : null}
      </div>
    </>
  )
}


const mapDispatchToProps = {
}
const mapStateToProps = (state) => {
  return {
    // userdata: state.userInfo,
    apiToken: state.apiToken
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Archived);
